import { useAppSelector } from '../store/hooks';

export const useGlobalFacultyFilter = () => {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const applyGlobalFacultyFilter = (localMaKhoa?: string[]): string[] | undefined => {
		if (selectedFaculty) {
			return [selectedFaculty];
		}
		return localMaKhoa;
	};

	return {
		selectedFaculty,
		applyGlobalFacultyFilter,
		hasGlobalFilter: !!selectedFaculty,
	};
};
